import axios from 'axios'
import store from '../store'
import pjson from '../../../../../../package.json';
import platform from 'platform';

window.axios = axios;
axios.defaults.withCredentials = true; // For Laravel Sanctum
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

// MLD-2410
axios.interceptors.request.use(request => {
  if (store.getters.csrfToken) { // MLD-4934
    request.headers['X-CSRF-TOKEN'] = store.getters.csrfToken;
    //request.headers['Authorization'] = `Bearer ${token}`
  }

  // MLD-2754
  if (store.getters.temporaryToken) {
    //console.log('using temporary token', store.getters.temporaryToken);
    request.headers['X-TEMPORARY-TOKEN'] = store.getters.temporaryToken;
    //console.log('SET X-TEMPORARY-TOKEN', store.getters.temporaryToken);
  }

  const deviceUUID = store.getters.mlv;
  request.headers['X-ML-DEVICE-UUID'] = deviceUUID;
  request.headers['X-ML-DEVICE-NAME'] = deviceUUID;
  request.headers['X-ML-DEVICE-SYSTEM-NAME'] = platform.os.family;
  request.headers['X-ML-DEVICE-SYSTEM-VERSION'] = platform.os.version;
  request.headers['X-ML-DEVICE-MODEL'] = 'browser';
  request.headers['X-ML-DEVICE-LOCAL-MODEL'] = 'browser';
  request.headers['X-ML-DEVICE-APP-NAME'] = pjson.name;
  request.headers['X-ML-DEVICE-APP-VERSION'] = pjson.version;
  request.headers['X-ML-DEVICE-APP-BUILD'] = 0;

  return request
});
